import React from 'react';
import { DATA_HOOK } from '../../ListItemAction.constants';
import { classes, st } from '../../ListItemAction.st.css.js';
export const PrefixIcon = ({ prefixIcon, size, subtitle, }) => {
    return React.cloneElement(prefixIcon, {
        size: size === 'medium' ? 24 : 18,
        className: st(classes.prefixIcon, { subtitle: Boolean(subtitle) }),
        'data-hook': DATA_HOOK.prefixIcon,
    });
};
//# sourceMappingURL=PrefixIcon.js.map